import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  inner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `15px 15px`,
    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
    },
  },
  links: {
    marginLeft: '15px',
    marginRight: '15px',
    fontFamily: 'Arial, sans-serif',
    display: 'flex',
    alignItems: 'center',
    [theme.fn.smallerThan('sm')]: {
      marginTop: '10px',
      marginBottom: '10px',
      width: '95%',
    },
    [theme.fn.smallerThan(501)]: {
      flexDirection: 'column',
      alignItems: 'initial',
      paddingLeft: '20px',
    },
  },
  innerBottom: {
    height: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
    padding: `10px 0px`,
    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
      marginBottom: '19px',
    },
    [theme.fn.smallerThan(501)]: {
      alignItems: 'initial',
    },
  },
  copyrightTrademark: {
    fontSize: '12px',
    paddingLeft: '30px',
    [theme.fn.smallerThan('sm')]: {
      paddingLeft: '0px',
    },
    [theme.fn.smallerThan(501)]: {
      paddingLeft: '20px',
    },
  },
  footerItem: {
    width: 'fit-content',
    paddingTop: '10px',
    cursor: 'pointer',
    whiteSpace: 'pre',
    textAlign: 'left',
    color: '#ffffff',
    textDecoration: 'none',
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1,
    paddingRight: '10px',
    paddingLeft: '10px',
    '&:hover': {
      opacity: 0.85,
    },
    [theme.fn.smallerThan('sm')]: {
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },
  streamNowButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '0',
    right: '0',
    height: '100px',
  },
  imgLogo: {
    marginLeft: '20px',
    width: '146px',
    height: '100px',
    [theme.fn.smallerThan(430)]: {
      transform: 'translate(0px, 12px)',
      width: '120px',
      height: '82px',
    },
  },
  logoLink: {
    display: 'inline-block',
    height: 'auto',
    '&:hover': {
      opacity: 0.85,
    },
  },
  logoWrapper: {
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '0',
    left: '0',
  },
  asianTextBlock: {
    whiteSpace: 'nowrap',
  },
}))
